<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ant"> </p>
<p class="FMH"><span class="ePub-BI">Author’s Note</span></p>
<p class="FMTNI">Several names in this book have been changed, at the request of the people whose stories I have told. The reasons for this will become evident when reading the stories of Phil and Edgar, of Hopey Molefe, of Adam, and of Bea and Katie.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// authorsnote.vue?2287b312